import { render } from "./InfiniteLoading.vue?vue&type=template&id=06d855d0"
import script from "./InfiniteLoading.vue?vue&type=script&lang=js"
export * from "./InfiniteLoading.vue?vue&type=script&lang=js"

import "./InfiniteLoading.vue?vue&type=style&index=0&id=06d855d0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__